<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{
            name: menu_trans,
            icon: 'fa fa-database text-info',
            icon: 'ni ni-shop text-primary'
          }"
        >
          <sidebar-item
            :link="{
              name: menu_trans,
              icon: 'fa fa-database text-info',
              path: '/lmg/transaction'
            }"
          >
          </sidebar-item>

		  <sidebar-item
            :link="{
              name: menu_invoice,
              icon: 'fa fa-database text-info',
              path: '/lmg/invoice'
            }"
          >
          </sidebar-item>

          <!-- <sidebar-item
            :link="{
              name: menu_billing,
              icon: 'fa fa-database text-info',
              path: '/lmg/billing'
            }"
          >
          </sidebar-item> -->

          <sidebar-item
            :link="{
              name: menu_payment,
              icon: 'fa fa-database text-info',
              path: '/lmg/payment'
            }"
          >
          </sidebar-item>

		  <sidebar-item
            :link="{
              name: menu_wht,
              icon: 'fa fa-database text-info',
              path: '/lmg/wht'
            }"
          >
          </sidebar-item>

          
          <sidebar-item
            :link="{
              name: menu_cash_clear,
              icon: 'fa fa-database text-info',
              path: '/lmg/cashclear'
            }"
            v-if="IsAdmin"
          >
          </sidebar-item>
        </sidebar-item>

		<sidebar-item
            :link="{
              name: menu_billing_report,
              icon: 'fa fa-reports text-info',
              path: '/lmg/billingreport'
            }"
            v-if="IsAdmin"
          >
          </sidebar-item>


        <sidebar-item
          :link="{
            name: menu_database,
            icon: 'fa fa-database text-primary'
          }"
            v-if="IsAdmin"
        >
       <sidebar-item
            :link="{
              name: menu_customer,
              icon: 'fa fa-database text-info',
              path: '/lmg/customer'
            }"
          >
          </sidebar-item>
        </sidebar-item>


        <sidebar-item
          :link="{
            name: menu_setting,
            icon: 'ni ni-settings text-primary'
          }"
            v-if="IsAdmin"
        >

			<sidebar-item
            :link="{
              name: menu_bank,
              icon: 'fa fa-database text-info',
              path: '/lmg/bank'
            }"
            v-if="IsAdmin"
          >
          </sidebar-item>

          <sidebar-item
            :link="{
              name: menu_insure,
              icon: 'fa fa-database text-info',
              path: '/lmg/insurance'
            }"
            v-if="IsAdmin"
          >
          </sidebar-item>

        <sidebar-item
            :link="{
              name: menu_ttype,
              icon: 'fa fa-database text-info',
              path: '/lmg/transactiontype'
            }"
            v-if="IsAdmin"
          >
          </sidebar-item>
         

          <sidebar-item
            :link="{
              name: menu_comm,
              icon: 'fa fa-database text-info',
              path: '/lmg/commission'
            }"
            v-if="IsAdmin"
          >
          </sidebar-item>

          <sidebar-item
            :link="{
              name: menu_person,
              icon: 'fa fa-database text-info',
              path: '/lmg/person'
            }"
            v-if="IsAdmin"
          >
          </sidebar-item>

          


          

        </sidebar-item>

        <sidebar-item
          :link="{
            name: menu_admin,
            icon: 'ni ni-single-02 text-primary'
          }"
            v-if="IsAdmin"
        >
          <sidebar-item
            :link="{
              name: menu_user,
              icon: 'fa fa-database text-info',
              path: '/lmg/user'
            }"
            v-if="IsAdmin"
          >
          </sidebar-item>
        </sidebar-item>

        

         <a
      class="sidebar-menu-item nav-link"
      @click="handleLogout()"
    >
     <i class="ni ni-lock-circle-open text-primary"></i>
<span class="nav-link-text"> {{ menu_logout }}</span>
    </a>


      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition
  },
  computed: {
    menu_logout: function() {
      return this.$t("auth.signout");
    },
    menu_user: function() {
      return this.$t("menu.user");
    },

    /// TLD
    menu_admin: function() {
      return this.$t("menu.admin");
    },
    menu_setting: function() {
      return this.$t("menu.setting");
    },

    menu_database: function() {
      return this.$t("menu.database");
    },
    
    menu_bank: function() {
      return this.$t("menu.bank");
    },
    menu_billing: function() {
      return this.$t("menu.billing");
    },
    menu_billing_report: function() {
      return this.$t("menu.billing_report");
    },
	menu_invoice: function() {
      return this.$t("menu.invoice");
    },
    menu_branch: function() {
      return this.$t("menu.branch");
    },
    menu_comm: function() {
      return this.$t("menu.comm");
    },
    menu_comm_extra: function() {
      return this.$t("menu.comm_extra");
    },
    menu_insure: function() {
      return this.$t("menu.insure");
    },
    menu_payment: function() {
      return this.$t("menu.payment");
    },
    menu_trans: function() {
      return this.$t("menu.trans");
    },
	menu_trans_cancel: function() {
      return this.$t("menu.trans_cancel");
    },
    menu_ttype: function() {
      return this.$t("menu.ttype");
    },
    menu_person: function() {
      return this.$t("menu.person");
    },
    menu_customer: function() {
      return this.$t("menu.customer");
    },
    menu_cash_clear: function() {
      return this.$t("menu.cash_clear");
    },
	menu_wht: function() {
      return this.$t("menu.wht");
    },


    ...mapGetters({
      getUser: "Auth/getUser"
    })
  },
  methods: {
    ...mapActions({
      setUser: "Auth/setUser",
      IsAdmin: "Auth/IsAdmin",
      IsEmployee: "Auth/IsEmployee",
      IsReadonly: "Auth/IsReadonly",
      signOut: "Auth/signOut"
    }),
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    handleLogout(){
      this.$cookie.delete("token");
      this.signOut();
      this.$router.push("/login");
    }
  },
  mounted() {
    // this.user = localStorage.getItem('user')

    this.initScrollbar();
  }
};
</script>
<style lang="scss">
.text-app {
  color: #19aaf8;
}
</style>
